import { render, staticRenderFns } from "./Home-adminSumRegion.vue?vue&type=template&id=052d1789&scoped=true&"
import script from "./Home-adminSumRegion.vue?vue&type=script&lang=js&"
export * from "./Home-adminSumRegion.vue?vue&type=script&lang=js&"
import style0 from "./Home-adminSumRegion.vue?vue&type=style&index=0&id=052d1789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d1789",
  null
  
)

export default component.exports